'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIn = require('./getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _set = require('./set');

var _set2 = _interopRequireDefault(_set);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (keyPath, newParcelData) {
    return function (parcelData) {
        for (var i = keyPath.length - 1; i >= 0; i--) {
            var partialKeyPath = keyPath.slice(0, i);
            newParcelData = (0, _pipeWith2.default)(parcelData, (0, _getIn2.default)(partialKeyPath), (0, _set2.default)(keyPath[i], newParcelData));
        }
        return newParcelData;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/setIn.js
// module id = 752
// module chunks = 35783957827783